export const TrustpilotIcon = () => {
  return (
    <svg
      aria-label="Trustpilot icon"
      fill="none"
      height="21"
      role="img"
      viewBox="0 0 22 21"
      width="22"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.9141 15.7539L15.6565 14.5521L17.6379 20.6588L10.9141 15.7539ZM21.8281 7.86072H13.4802L10.9141 0L8.34796 7.86072H0L6.75633 12.7331L4.19022 20.5938L10.9465 15.7214L15.1043 12.7331L21.8281 7.86072Z"
        fill="#219653"
      />
    </svg>
  );
};
